module.exports = __webpack_public_path__ + "img/ai04.697584b5.png";